export default {
  settings: [],
  default: [
    {
      channel: "live",
      status: true,
      settings: {
        sources: [
          {
            _id: "1",
            name: "Nowgoal",
            url: "https://nowgoal.com",
            status: true
          },
          {
            _id: "2",
            name: "Goaloo",
            url: "https://goaloo.com",
            status: false
          }
        ],
        matchList: {
          url: "/",
          file: "/gf/data/bf_en2.js",
          arrayVar: "A",
          indexes: {
            _id: "0",
            home: {
              _id: "2",
              name: "4"
            },
            away: {
              _id: "3",
              name: "5"
            },
            start: "6",
            part: "8"
          },
          xpath: {
            active:
              "//table[@id='table_live']/tbody/tr[starts-with(@id, 'tr1')]/td[starts-with(@id, 'time_')][text()!='\u00a0']/..|//table[@id='table_live']/tbody/tr[starts-with(@id, 'tr1')]/td[starts-with(@id, 'time_')]/font/../.."
          }
        },
        match: {
          detail: {
            url: "/detail/{id}.html",
            keyEvents: {
              xpath:
                "//x:div[@id='matchData']/x:div[2]/x:div[@class='content']/x:table[@class='bhTable']/x:tbody/x:tr/x:th[text()='Key Events']/../../x:tr[position()>1]"
            },
            tech: {
              xpath:
                "//x:div[@id='matchData']/x:div[2]/x:div[@class='content']/x:table[@class='bhTable']/x:tbody/x:tr/x:th[text()='Tech Statistics']/../../x:tr[position()>1]"
            },
            team: {
              xpath:
                "//x:div[@id='matchData']/x:div[2]/x:div[@class='content']/x:table[@class='bhTable']/x:tbody/x:tr/x:th[text()='Team Statistics']/../../x:tr[position()>2]"
            },
            sm: {
              xpath:
                "//x:div[@id='matchData']/x:div[2]/x:div[@class='content']/x:table[@id='jsq30']/x:tbody/x:tr/x:th[text()='The Rate of Scored / Missed']/../../x:tr[position()>2]"
            }
          },
          odds: {
            url: "data.{domain}/oddscomp/{id}.html",
            odds: {
              xpath:
                "//x:div[@id='main']/x:table[@class='oddstable'][1]/x:tbody/x:tr/x:td[contains(text(), 'Bet365')]/../x:td[9]/text()"
            }
          },
          winRate: {
            url: "/1x2/{id}.htm",
            rate: {
              xpath:
                "//!*[@id='avgRObj']/td[2]/text() | //!*[@id='avgRObj']/td[4]/text() | //!*[@id='avgRObj']/td[2]/span/text() | //!*[@id='avgRObj']/td[4]/span/text()"
            }
          }
        }
      }
    },
    {
      channel: "line",
      status: true,
      settings: {
        sources: [
          {
            _id: "1",
            name: "Forebet",
            url: "https://www.forebet.com/en",
            status: true
          }
        ],
        time: "03:30:00",
        matchList: {
          url:
            "/football-tips-and-predictions-for-today/predictions-under-over-goals",
          percent: "60",
          rate: {
            from: "1.5",
            to: "1.8"
          },
          xpath: {
            matches:
              '//!*[@id="body-wrapper"]/table/tbody/tr[4]/td/table/tbody/tr[1]/td[2]/table/tbody/tr/td[2]/div/table/tbody/tr/td[4]/span[text()="Over"]/../..',
            more: '//!*[@id="mrows"]/td/span',
            loader: '//!*[@id="mrows"]/td/div'
          }
        },
        match: {
          detail: {
            start: {
              xpath:
                '//x:div[@id="body-wrapper"]/x:table/x:tbody/x:tr[4]/x:td/x:table/x:tbody/x:tr[1]/x:td[2]/x:table/x:tbody/x:tr/x:td[2]/x:div/x:div[2]/x:div[2]/x:div[2]/x:time/x:div/text()'
            },
            league: {
              xpath:
                '//x:div[@id="body-wrapper"]/x:table/x:tbody/x:tr[4]/x:td/x:table/x:tbody/x:tr[1]/x:td[2]/x:table/x:tbody/x:tr/x:td[2]/x:div/x:div[3]/x:center/x:a/text()'
            }
          }
        }
      }
    }
  ]
};
